import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const regionService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/region/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching region list", error);
            throw error;
        }
    },

    async findById(regionId: number): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/region/findById/${regionId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById region", error);
            throw error;
        }
    },

    async save(region: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/region/save`,
                region
            );
            return response.data;
        } catch (error) {
            console.error("Error save region", error);
            throw error;
        }
    },

    async deleteById(regionId: number): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/region/deleteById/${regionId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById region", error);
            throw error;
        }
    }
}

export default regionService;